import type { TutorialDetailMap } from '@/utils/tutorialTypes';

export const tutorialDetailsMt5StartChart: TutorialDetailMap = {
  'mt5-download-install': {
    intro: [
      'ตัวติดตั้ง MT5 แยกจาก MT4 อย่างสิ้นเชิง แม้หน้าตาจะคล้ายกัน ไฟล์ที่ได้จากโบรกเกอร์จะเป็น mt5setup.exe ขนาดราว 4-6 MB และติดตั้งเสร็จใน 2-3 นาที',
      'จุดที่มือใหม่พลาดบ่อยที่สุดคือโหลดตัวติดตั้งผิดรุ่น แล้วพบว่าล็อกอินด้วยบัญชี MT5 ไม่ได้ทั้งที่รหัสถูก',
    ],
    sections: [
      {
        heading: 'แยกให้ออกระหว่าง MT4 กับ MT5',
        paragraphs: [
          'MT4 และ MT5 เป็นคนละโปรแกรม ใช้ไฟล์ติดตั้งคนละตัว และบัญชีซื้อขายก็แยกกันในบางโบรกเกอร์ การติดตั้ง MT4 ไว้แล้วจึงไม่ได้แปลว่าจะเปิดบัญชี MT5 ได้',
          'สังเกตง่าย ๆ ที่ชื่อไฟล์และโลโก้บนหน้าต่างโปรแกรม ถ้าเห็นเลข 5 แสดงว่าเป็น MT5 และในหน้าต่าง Login จะมีชื่อเซิร์ฟเวอร์ที่ลงท้ายด้วย MT5',
        ],
        bullets: [
          'ไฟล์ MT5 ชื่อ mt5setup.exe ไม่ใช่ mt4setup.exe',
          'บัญชี MT4 ใช้ล็อกอิน MT5 ไม่ได้ในหลายโบรกเกอร์',
          'ชื่อเซิร์ฟเวอร์ MT5 มักมีคำว่า MT5 ต่อท้าย',
        ],
      },
      {
        heading: 'ขั้นตอนติดตั้งและล็อกอินครั้งแรก',
        paragraphs: [
          'เข้าเว็บโบรกเกอร์ เลือกเมนู Platforms แล้วเลือก MetaTrader 5 ให้ตรงระบบปฏิบัติการ เปิดไฟล์แล้วกด Next ตามค่าเริ่มต้น 3 หน้าจอ',
          'เมื่อโปรแกรมเปิดขึ้น ให้เลือก File > Login to Trade Account แล้วกรอกเลขบัญชี รหัสผ่าน และเลือกเซิร์ฟเวอร์ MT5 จากรายการ ใช้เวลาราว 1 นาที',
        ],
        bullets: [
          'เลือกเวอร์ชันให้ตรงกับ Windows หรือ macOS',
          'กด Next ตามค่าเริ่มต้น ไม่ต้องเปลี่ยนโฟลเดอร์',
          'ล็อกอินด้วยเซิร์ฟเวอร์ที่ลงท้าย MT5',
          'ตรวจตัวเลข ping มุมขวาล่างก่อนเริ่มใช้งาน',
        ],
      },
      {
        heading: 'ปัญหาที่เจอบ่อยตอนติดตั้ง',
        paragraphs: [
          'กรณีที่พบบ่อยคือติดตั้งแล้วล็อกอินไม่ผ่านเพราะบัญชีที่ได้มาเป็นบัญชี MT4 ซึ่งแก้ไม่ได้ด้วยการลองรหัสซ้ำ ต้องขอบัญชี MT5 จากโบรกเกอร์',
          'อีกกรณีคือ Windows SmartScreen บล็อกไฟล์ติดตั้ง เพราะไม่รู้จักผู้พัฒนา ให้กด More info แล้วเลือก Run anyway ซึ่งปลอดภัยเมื่อโหลดจากเว็บโบรกเกอร์โดยตรง',
        ],
        bullets: [
          'ล็อกอินไม่ผ่าน ให้ตรวจว่าเป็นบัญชี MT5 จริง',
          'SmartScreen บล็อก ให้กด More info > Run anyway',
          'ถ้าเครื่องมี MT4 อยู่แล้ว ไม่ต้องถอนการติดตั้ง',
          'ควรติดตั้งแยกโฟลเดอร์จาก MT4 โดยอัตโนมัติ',
        ],
      },
      {
        heading: 'ตรวจงานหลังติดตั้ง',
        paragraphs: [
          'หลังล็อกอินสำเร็จ ให้เปิดกราฟ EURUSD บน H1 แล้วตรวจว่ามีแท่งเทียนย้อนหลังอย่างน้อย 100 แท่ง ซึ่งยืนยันว่าได้รับข้อมูลครบ',
          'จากนั้นลองเปิดหน้าต่าง New Order ดูว่ามีช่อง Stop Loss และ Take Profit แสดงครบ ถ้าครบแปลว่าพร้อมใช้งานจริง',
        ],
        bullets: [
          'มุมขวาล่างต้องขึ้น connected พร้อม ping',
          'กราฟ H1 ต้องมีแท่งเทียนครบ 100 แท่งขึ้นไป',
          'หน้าต่าง New Order ต้องมีช่อง SL และ TP',
          'บันทึกเลขบัญชีและชื่อเซิร์ฟเวอร์ไว้ใช้ในอนาคต',
        ],
      },
    ],
    faqs: [
      {
        q: 'มี MT4 อยู่แล้ว ต้องติดตั้ง MT5 อีกไหม',
        a: 'ต้องติดตั้งแยก เพราะเป็นคนละโปรแกรม และสามารถติดตั้งไว้พร้อมกันบนเครื่องเดียวได้โดยไม่ชนกัน',
        a2: 'ข้อควรรู้คือทั้งสองโปรแกรมจะใช้พื้นที่คนละโฟลเดอร์ข้อมูล จึงเก็บอินดิเคเตอร์แยกกัน อินดิเคเตอร์ที่ติดตั้งใน MT4 จะไม่ปรากฏใน MT5 และไฟล์ .ex4 ของ MT4 ก็นำมาใช้กับ MT5 ไม่ได้ ต้องหาเวอร์ชัน .ex5 แยก',
      },
      {
        q: 'บัญชี MT4 ใช้ล็อกอิน MT5 ได้ไหม',
        a: 'โดยทั่วไปไม่ได้ เพราะโบรกเกอร์แยกบัญชีตามแพลตฟอร์ม ต้องสอบถามโบรกเกอร์ว่าต้องเปิดบัญชีใหม่หรือไม่',
        a2: 'บางโบรกเกอร์ให้เลขบัญชีเดียวกันใช้ได้ทั้งสองแพลตฟอร์ม แต่ประวัติการเทรดจะแยกกัน และบางแห่งต้องเปิดบัญชีใหม่พร้อมโอนเงินเข้าใหม่ คำถามที่ควรถามให้ชัดคือ ใช้เลขบัญชีเดิมได้ไหม มีค่าธรรมเนียมโอนย้ายไหม และประวัติเดิมยังดูได้หรือไม่',
      },
      {
        q: 'ติดตั้ง MT5 บนมือถือต้องทำอะไรเพิ่ม',
        a: 'ดาวน์โหลดแอป MetaTrader 5 จาก App Store หรือ Google Play แล้วล็อกอินด้วยบัญชีเดียวกับบนคอมพิวเตอร์',
        a2: 'สิ่งที่ทำบนมือถือไม่ได้คือติดตั้งอินดิเคเตอร์ภายนอกและการรัน EA เต็มรูปแบบ อีกทั้งหน้าจอเล็กทำให้อ่านกราฟ H4 ย้อนหลัง 200 แท่งได้ไม่สะดวก แนะนำให้ใช้มือถือตรวจสถานะและปิดออเดอร์ ส่วนการวิเคราะห์ให้ทำบนคอมพิวเตอร์',
      },
    ],
  },
  'mt5-login-account': {
    intro: [
      'บัญชี MT5 ต้องมาจากโบรกเกอร์ที่รองรับแพลตฟอร์มนี้ และต้องเป็นบัญชีที่สร้างมาสำหรับ MT5 โดยเฉพาะในหลายกรณี',
      'การล็อกอินใช้สามค่าเหมือน MT4 คือเลขบัญชี รหัสผ่าน และชื่อเซิร์ฟเวอร์ แต่ MT5 มีจุดที่ต้องระวังเพิ่มคือประเภทบัญชี Netting กับ Hedging',
    ],
    sections: [
      {
        heading: 'สามค่าที่ต้องตรงกัน',
        paragraphs: [
          'เลขบัญชีคือตัวเลขที่โบรกเกอร์ส่งมาทางอีเมล ส่วนรหัสผ่านคือรหัสของบัญชีซื้อขาย ซึ่งบางโบรกเกอร์แยกจากรหัสเข้าเว็บไซต์',
          'ชื่อเซิร์ฟเวอร์ของ MT5 มักมีคำว่า MT5 หรือ Live5 ต่อท้าย การเลือกเซิร์ฟเวอร์ของ MT4 จะขึ้น Invalid account แม้รหัสจะถูก',
        ],
        bullets: [
          'Login = เลขบัญชีจากอีเมล',
          'Password = รหัสบัญชีซื้อขาย',
          'Server = ชื่อที่ระบุ MT5 หรือ Live5',
        ],
      },
      {
        heading: 'ขั้นตอนล็อกอิน',
        paragraphs: [
          'เปิด MT5 ไปที่ File > Login to Trade Account กรอกข้อมูลทั้งสามช่อง แล้วกด Login รอ 3-5 วินาที',
          'ถ้าสำเร็จมุมขวาล่างจะขึ้น connected พร้อมตัวเลข ping และ Market Watch จะเริ่มมีราคาไหล ถ้าไม่สำเร็จจะมีข้อความบอกสาเหตุ',
        ],
        bullets: [
          'กด Ctrl+L เปิดหน้าต่างล็อกอินได้เร็วขึ้น',
          'ติ๊ก Save account information เก็บข้อมูลไว้',
          'ถ้าเลือกเซิร์ฟเวอร์ถูกต้อง รายการจะแสดงชื่อโบรกเกอร์',
          'ตรวจราคาใน Market Watch ว่าไหลจริงหลังล็อกอิน',
        ],
      },
      {
        heading: 'Netting กับ Hedging กระทบการล็อกอินอย่างไร',
        paragraphs: [
          'บัญชี Netting จะรวมออเดอร์ทิศเดียวกันเป็นสถานะเดียว ส่วน Hedging ถือแยกได้หลายออเดอร์ ต้องเลือกเซิร์ฟเวอร์ให้ตรงกับประเภทบัญชีที่สมัครไว้',
          'ถ้าเลือกผิดประเภท ระบบอาจให้ล็อกอินได้แต่พฤติกรรมการเปิดออเดอร์จะไม่ตรงกับที่คาด เช่น เปิด Buy ซ้ำแล้วกลายเป็นเพิ่มขนาดแทนการถือสองไม้',
        ],
        bullets: [
          'Netting รวมสถานะทิศเดียวกัน',
          'Hedging ถือแยกได้หลายออเดอร์',
          'ประเภทบัญชีถูกกำหนดตอนสมัคร ไม่สามารถสลับเองได้',
        ],
      },
      {
        heading: 'ล็อกอินไม่ผ่านให้ไล่ตรวจ',
        paragraphs: [
          'เริ่มจากคัดลอกชื่อเซิร์ฟเวอร์จากอีเมลมาเทียบทีละตัวอักษร เพราะสาเหตุอันดับหนึ่งคือเลือกเซิร์ฟเวอร์ผิด ไม่ใช่รหัสผิด',
          'ถ้าแน่ใจว่าถูกทั้งหมด ให้ตรวจว่าโบรกเกอร์เปิดบัญชีให้เป็น MT5 จริง เพราะบางแห่งให้เฉพาะ MT4 กับบัญชีที่สมัครผ่านหน้าเว็บปกติ',
        ],
        bullets: [
          'ตรวจ Caps Lock และช่องว่างในรหัสผ่าน',
          'ตรวจว่าเซิร์ฟเวอร์เป็นของ MT5',
          'ลองล็อกอินบัญชีทดลองเพื่อแยกสาเหตุ',
          'ถ้ายังไม่ผ่านให้ติดต่อโบรกเกอร์พร้อมข้อความ error',
        ],
      },
    ],
    faqs: [
      {
        q: 'ล็อกอิน MT5 ไม่ผ่านทั้งที่รหัสถูก',
        a: 'สาเหตุที่พบบ่อยที่สุดคือเลือกเซิร์ฟเวอร์ผิด หรือบัญชีนั้นถูกสร้างสำหรับ MT4 ไม่ใช่ MT5',
        a2: 'ให้เปิดอีเมลของโบรกเกอร์ดูว่ามีคำว่า MT5 ในชื่อเซิร์ฟเวอร์หรือไม่ ถ้าไม่มีเลยแสดงว่าบัญชีนี้เป็นของ MT4 ต้องขอบัญชี MT5 เพิ่ม ซึ่งบางโบรกเกอร์เปิดให้ในหน้า Client Portal ภายใน 1-2 นาที',
      },
      {
        q: 'จะรู้ได้อย่างไรว่าบัญชีเป็น Netting หรือ Hedging',
        a: 'ดูได้จากหน้า Client Portal ของโบรกเกอร์ หรือจากหน้าต่าง Specification ในแพลตฟอร์มหลังล็อกอินสำเร็จ',
        a2: 'ถ้าดูจากแพลตฟอร์ม ให้เปิด Market Watch คลิกขวาที่คู่เงินแล้วเลือก Specification แล้วดูหัวข้อ Margin mode หรือ Position accounting ซึ่งจะระบุว่า Netting หรือ Hedging การรู้ประเภทบัญชีสำคัญมากเพราะมีผลกับการปิดออเดอร์บางส่วน',
      },
      {
        q: 'ใช้ MT5 หลายบัญชีพร้อมกันได้ไหม',
        a: 'ได้ MT5 รองรับหลายบัญชี แต่ละบัญชีมีกราฟและประวัติแยกกัน',
        a2: 'ถ้าต้องเฝ้าหลายบัญชีพร้อมกัน ให้เปิดโปรแกรม MT5 ซ้ำอีกหน้าต่างโดยติดตั้งแยกโฟลเดอร์ วิธีนี้ทำให้เห็นทั้งสองบัญชีพร้อมกัน แต่กินแรมเพิ่มราว 400-600 MB ต่อหน้าต่าง จึงควรมีแรมอย่างน้อย 8 GB',
      },
    ],
  },
  'mt5-screen-overview': {
    intro: [
      'หน้าจอ MT5 คล้าย MT4 แต่เปลี่ยนชื่อบางส่วนและเพิ่มแท็บเครื่องมือวิเคราะห์เข้ามาในหน้าต่างด้านล่างที่เรียกว่า Toolbox',
      'ทำความรู้จักสี่ส่วนหลักก่อน จะช่วยให้ตามบทความอื่น ๆ ได้ง่ายขึ้นมาก',
    ],
    sections: [
      {
        heading: 'สี่ส่วนหลักของหน้าจอ MT5',
        paragraphs: [
          'Market Watch อยู่มุมซ้ายบน ใช้ดูราคาและเลือกสินทรัพย์ ซึ่ง MT5 รองรับทั้ง Forex หุ้น ดัชนี และฟิวเจอร์สในหน้าต่างเดียว',
          'Navigator อยู่มุมซ้ายล่างเก็บอินดิเคเตอร์และเครื่องมือวิเคราะห์ ส่วน Toolbox ด้านล่างแทน Terminal ของ MT4',
        ],
        bullets: [
          'Market Watch — ดูราคาและเลือกสินทรัพย์ (Ctrl+M)',
          'Navigator — เรียกอินดิเคเตอร์และเครื่องมือ (Ctrl+N)',
          'Toolbox — ดูออเดอร์ ประวัติ และปฏิทินเศรษฐกิจ (Ctrl+T)',
          'กราฟกลางจอ — พื้นที่วิเคราะห์หลัก',
        ],
      },
      {
        heading: 'Toolbox ต่างจาก Terminal ของ MT4 ตรงไหน',
        paragraphs: [
          'Toolbox มีแท็บมากกว่า Terminal เช่น Economic Calendar ที่แสดงปฏิทินข่าวในตัว และ Overview ที่สรุปสถานะบัญชี',
          'แท็บ Trade รวมสถานะที่เปิดอยู่ ส่วน History เก็บออเดอร์ที่ปิดแล้ว และแยกดูได้ทั้ง Positions, Orders และ Deals',
        ],
        bullets: [
          'Economic Calendar มีมาในตัว ไม่ต้องเปิดเว็บภายนอก',
          'Overview สรุปยอดเงินและ margin',
          'History แยกดูได้ 3 แบบ',
          'กด Ctrl+T เปิดหรือปิด Toolbox',
        ],
      },
      {
        heading: 'แถบเครื่องมือและกรอบเวลา 21 แบบ',
        paragraphs: [
          'แถบเครื่องมือด้านบนมีปุ่มกรอบเวลาที่ใช้บ่อย ส่วนกรอบที่เหลือเข้าถึงได้จาก Charts > Timeframe ซึ่ง MT5 มีให้เลือกถึง 21 กรอบ',
          'ปุ่มที่มือใหม่ใช้บ่อยคือปุ่มกรอบเวลา ปุ่มเส้นแนวโน้ม และปุ่มซูมกราฟ ส่วนปุ่มอื่นเปิดจากเมนูเมื่อจำเป็น',
        ],
        bullets: [
          'กรอบเวลามี 21 แบบ มากกว่า MT4 ถึง 12 แบบ',
          'ปุ่ม Candlestick ใช้สลับรูปแบบกราฟ',
          'กด Ctrl+Y เปิดรายการวัตถุบนกราฟ',
          'ปุ่ม End กลับมาที่ราคาล่าสุด',
        ],
      },
      {
        heading: 'จัดหน้าจอให้เหมาะกับการเทรด',
        paragraphs: [
          'หน้าจอเริ่มต้นแสดงทุกอย่างพร้อมกันจนพื้นที่กราฟเหลือน้อย ลองย่อ Toolbox เหลือความสูงราว 150 px และปิด Navigator เมื่อไม่ได้ใช้',
          'ถ้าใช้จอเดียว แนะนำเปิดกราฟ H4 สำหรับดูทิศทาง และ H1 สำหรับหาจุดเข้า ซึ่งเพียงพอสำหรับการเทรดทั่วไป',
        ],
        bullets: [
          'ย่อ Toolbox เหลือ 150 px พอเห็นแท็บ Trade',
          'ปิด Navigator จะได้พื้นที่กราฟเพิ่มราว 15%',
          'บันทึกหน้าจอที่จัดไว้ด้วย File > Profiles',
          'ไม่ควรเปิดกราฟเกิน 8 หน้าต่างบนเครื่องทั่วไป',
        ],
      },
    ],
    faqs: [
      {
        q: 'Toolbox หายไป จะเปิดคืนอย่างไร',
        a: 'ไปที่เมนู View > Toolbox หรือกด Ctrl+T หน้าต่างจะกลับมาที่ตำแหน่งเดิม',
        a2: 'ถ้ากดแล้วยังไม่ขึ้น ให้ขยายหน้าต่างโปรแกรมให้เต็มจอก่อน เพราะบางครั้งพื้นที่ด้านล่างถูกตัดออกจนมองไม่เห็น แล้วกด Ctrl+T อีกครั้ง ถ้ายังไม่ขึ้นให้ปิดโปรแกรมแล้วเปิดใหม่ ระบบจะโหลดเลย์เอาต์ล่าสุดกลับมาให้',
      },
      {
        q: 'ทำไม MT5 มีกรอบเวลามากกว่า MT4',
        a: 'เพราะ MT5 ออกแบบมาให้รองรับสินทรัพย์หลายประเภทและความละเอียดเชิงเวลาที่สูงกว่า จึงเพิ่มกรอบอย่าง M2 M3 M4 M6 M10 M12 และ M20 เข้ามา',
        a2: 'ในทางปฏิบัติ กรอบที่เพิ่มมาใช้บ่อยจริงคือ M20 กับ H2-H3 ส่วนกรอบอื่นมีไว้เพื่อระบบที่ต้องการความละเอียดเฉพาะทาง ถ้าไม่เคยใช้กรอบเหล่านี้ การมี 21 กรอบอาจทำให้เลือกยากขึ้น จึงแนะนำให้ติดปุ่มที่ใช้บ่อยไว้บนแถบเครื่องมือ',
      },
      {
        q: 'หน้าจอ MT5 กินทรัพยากรกว่า MT4 ไหม',
        a: 'มากกว่าเล็กน้อย เพราะมีแท็บและเครื่องมือในตัวมากกว่า โดยใช้แรมราว 400-700 MB ในสภาวะปกติ',
        a2: 'ถ้าเปิดหลายกราฟพร้อมอินดิเคเตอร์และปฏิทินเศรษฐกิจ อาจใช้เกิน 1.5 GB จนเริ่มหน่วง วิธีลดภาระคือปิดแท็บ Economic Calendar เมื่อไม่ได้ดู ปิดกราฟที่ไม่ใช้ และหลีกเลี่ยงการเปิดกราฟ M1 หลายหน้าต่างพร้อมกัน',
      },
    ],
  },
  'mt5-market-watch': {
    intro: [
      'Market Watch ของ MT5 รองรับสินทรัพย์หลากหลายกว่า MT4 มาก ทั้ง Forex หุ้น ดัชนี และฟิวเจอร์สในหน้าต่างเดียว',
      'การจัดรายการให้เหลือเฉพาะสินทรัพย์ที่เทรดจริงช่วยลดภาระเครื่องและทำให้ตัดสินใจได้เร็วขึ้น',
    ],
    sections: [
      {
        heading: 'เปิดและอ่านค่าใน Market Watch',
        paragraphs: [
          'กด Ctrl+M หรือไปที่ View > Market Watch ค่า Bid คือราคาที่ขายได้ และ Ask คือราคาที่ซื้อ ผลต่างคือ Spread ที่เป็นต้นทุนทันที',
          'MT5 แสดงจำนวนทศนิยมตามสินทรัพย์แต่ละประเภท เช่น Forex 5 หลัก แต่หุ้นอาจแสดง 2 หลัก ให้ดูที่ Specification ถ้าไม่แน่ใจ',
        ],
        bullets: [
          'Bid = ราคาขายออก, Ask = ราคาซื้อเข้า',
          'Ask ลบ Bid = Spread',
          'จำนวนทศนิยมต่างกันตามประเภทสินทรัพย์',
          'ตัวเลขสีฟ้าคือขึ้น สีแดงคือลง',
        ],
      },
      {
        heading: 'เพิ่มสินทรัพย์แยกตามหมวด',
        paragraphs: [
          'คลิกขวาแล้วเลือก Symbols จะมีหน้าต่างรายการสินทรัพย์แยกหมวด Forex, Stocks, Indices, Futures และอื่น ๆ ตามที่โบรกเกอร์เปิดให้',
          'ใช้ช่องค้นหาพิมพ์ชื่อย่อ เช่น EUR หรือ AAPL เพื่อกรอง แล้วดับเบิลคลิกเพื่อเพิ่มเข้าสู่รายการที่ติดตาม',
        ],
        bullets: [
          'Symbols แยกรายการตามหมวดสินทรัพย์',
          'ใช้ช่องค้นหาแทนการไล่เลื่อน',
          'ดับเบิลคลิกเพื่อเพิ่มเข้าสู่ Market Watch',
          'หมวดที่ว่างแปลว่าโบรกเกอร์ไม่ได้เปิดบริการ',
        ],
      },
      {
        heading: 'เพิ่มคอลัมน์ที่มีประโยชน์',
        paragraphs: [
          'คลิกขวาที่หัวตารางแล้วเลือก Spread เพื่อเทียบต้นทุนก่อนเลือกสินทรัพย์ ซึ่งมีประโยชน์มากเมื่อเทรดหลายตลาด',
          'นอกจากนี้ยังเพิ่มคอลัมน์ Time เพื่อดูเวลาอัปเดตล่าสุด และคอลัมน์ High/Low เพื่อดูช่วงราคาของวันได้',
        ],
        bullets: [
          'คอลัมน์ Spread ใช้เทียบต้นทุน',
          'คอลัมน์ Time บอกเวลาอัปเดตล่าสุด',
          'ตั้งค่าแล้วโปรแกรมจะจำไว้ให้',
          'ถ้าราคาไม่ไหลทั้งกระดาน ให้ตรวจการเชื่อมต่อ',
        ],
      },
      {
        heading: 'ข้อควรระวัง',
        paragraphs: [
          'สินทรัพย์บางหมวดจะแสดงก็ต่อเมื่อโบรกเกอร์เปิดให้เทรด ถ้ารายการว่างไม่ใช่โปรแกรมเสีย แต่คือโบรกเกอร์ไม่ได้ให้บริการส่วนนั้น',
          'อีกจุดคือหุ้นและดัชนีมีเวลาเปิดปิดตลาดต่างจาก Forex ราคาจะนิ่งในช่วงที่ตลาดนั้นปิด ซึ่งไม่ใช่ปัญหาการเชื่อมต่อ',
        ],
        bullets: [
          'หมวดว่าง = โบรกเกอร์ไม่ได้เปิด',
          'หุ้นและดัชนีมีเวลาเปิดปิดแยกจาก Forex',
          'เก็บสินทรัพย์ไว้ 6-10 รายการพอ',
          'Spread ของหุ้นมักกว้างกว่า Forex หลายเท่า',
        ],
      },
    ],
    faqs: [
      {
        q: 'ทำไม Market Watch ของ MT5 มีสินทรัพย์มากกว่า MT4',
        a: 'เพราะ MT5 รองรับหลายตลาดทั้ง Forex หุ้น ดัชนี และฟิวเจอร์ส ในขณะที่ MT4 เน้น Forex กับ CFD',
        a2: 'จำนวนที่เห็นขึ้นกับโบรกเกอร์เป็นหลัก บางแห่งเปิด Forex 60 คู่และหุ้น 200 ตัว แต่บางแห่งเปิดเฉพาะ Forex ถ้าต้องการทราบว่ามีอะไรบ้าง ให้เปิดหน้าต่าง Symbols แล้วดูจำนวนในแต่ละหมวด ซึ่งจะตรงกับที่เทรดได้จริง',
      },
      {
        q: 'เพิ่มสินทรัพย์แล้วราคาไม่ขึ้น',
        a: 'อาจเป็นช่วงที่ตลาดนั้นปิด หรือสินทรัพย์นั้นไม่ได้เปิดให้เทรดกับโบรกเกอร์ของคุณ',
        a2: 'ให้ตรวจคอลัมน์ Time ว่าอัปเดตล่าสุดเมื่อไร ถ้าเป็นเวลาหลายชั่วโมงก่อนและเป็นช่วงนอกเวลาทำการของตลาดนั้น ก็เป็นพฤติกรรมปกติ เช่น หุ้นสหรัฐเปิดเฉพาะช่วงค่ำถึงดึกตามเวลาไทย',
      },
      {
        q: 'ลบสินทรัพย์ออกจาก Market Watch อย่างไร',
        a: 'คลิกขวาที่ชื่อสินทรัพย์แล้วเลือก Hide หรือเข้าไปเอาติ๊กออกในหน้าต่าง Symbols',
        a2: 'ถ้าลบจนเหลือน้อยเกินไปและต้องการกลับมา ให้เปิด Symbols แล้วค้นหาชื่อเดิมอีกครั้ง ระบบจะจำการตั้งค่าคอลัมน์ไว้ให้ การลบไม่กระทบออเดอร์ที่เปิดอยู่ และไม่กระทบกราฟที่เปิดค้างไว้',
      },
    ],
  },
  'mt5-change-timeframe': {
    intro: [
      'MT5 มีกรอบเวลาให้เลือกถึง 21 แบบ รวมกรอบกลางอย่าง M2 ถึง M12 และ H2 ถึง H12 ที่ MT4 ไม่มี',
      'กรอบที่เพิ่มมาไม่ได้ทำให้วิเคราะห์เก่งขึ้น แต่ช่วยให้จับจังหวะได้ละเอียดขึ้นเมื่อจำเป็น',
    ],
    sections: [
      {
        heading: 'กรอบเวลาทั้ง 21 แบบ',
        paragraphs: [
          'MT5 มีกรอบนาที 12 แบบ ตั้งแต่ M1 ถึง M30 รวม M2 M3 M4 M6 M10 M12 M20 และกรอบชั่วโมง 9 แบบ รวม H2 H3 H6 H8 H12',
          'กรอบที่เหลือคือ D1 W1 และ MN1 ซึ่งใช้ดูแนวโน้มระยะยาวเหมือน MT4',
        ],
        bullets: [
          'กรอบนาที 12 แบบ รวม M20 ที่ใช้กันมาก',
          'กรอบชั่วโมง 9 แบบ รวม H2 H3 H6 H8 H12',
          'D1 W1 MN1 สำหรับระยะยาว',
          'MT4 มีเพียง 9 กรอบ',
        ],
      },
      {
        heading: 'วิธีเปลี่ยนกรอบเวลา',
        paragraphs: [
          'กดปุ่มกรอบเวลาบนแถบเครื่องมือสำหรับกรอบที่ใช้บ่อย หรือไปที่ Charts > Timeframe เพื่อเลือกจากรายการทั้งหมด',
          'หลังเปลี่ยนให้ดูชื่อกรอบมุมซ้ายบนของกราฟทุกครั้ง เพราะปุ่มอยู่ติดกันและกดพลาดได้ง่าย',
        ],
        bullets: [
          'ปุ่มบนแถบเครื่องมือสำหรับกรอบที่ใช้บ่อย',
          'Charts > Timeframe เข้าถึงครบ 21 กรอบ',
          'ตรวจชื่อกรอบมุมซ้ายบนทุกครั้ง',
          'กด Ctrl+F ซูมกราฟเมื่อแท่งเทียนดูเล็ก',
        ],
      },
      {
        heading: 'กรอบที่เพิ่มมาใช้ประโยชน์อย่างไร',
        paragraphs: [
          'M20 มีประโยชน์เพราะแบ่งหนึ่งชั่วโมงได้ลงตัว 3 แท่ง ทำให้เห็นจังหวะย่อยโดยไม่ถี่เท่า M15 หรือ M5',
          'H2 และ H3 ใช้ดูจังหวะกลางที่ละเอียดกว่า H4 เล็กน้อย เหมาะกับคนที่รู้สึกว่า H4 ช้าเกินไปแต่ H1 เร็วเกินไป',
        ],
        bullets: [
          'M20 แบ่งชั่วโมงได้ลงตัว 3 แท่ง',
          'H2-H3 เหมาะกับ swing ระยะกลาง',
          'กรอบที่ถี่ขึ้นทำให้สัญญาณหลอกมากขึ้น',
          'ไม่จำเป็นต้องใช้ทุกกรอบ',
        ],
      },
      {
        heading: 'เลือกกรอบให้เหมาะกับตัวเอง',
        paragraphs: [
          'หลักที่ใช้ได้จริงคือจับคู่กรอบใหญ่และกรอบเล็กให้ห่างกัน 4-6 เท่า เช่น ดู H4 เพื่อกำหนดทิศ แล้วใช้ H1 หาจุดเข้า',
          'ถ้ามีเวลาดูจอน้อยกว่า 1 ชั่วโมงต่อวัน ให้ใช้ H4 หรือ D1 เป็นหลัก แล้วตั้งคำสั่งรอราคาแทนการเฝ้าหน้าจอ',
        ],
        bullets: [
          'กรอบใหญ่กับเล็กควรห่างกัน 4-6 เท่า',
          'มีเวลาน้อยใช้ H4 หรือ D1',
          'กรอบเล็กต้องคิดถึง Spread เป็นพิเศษ',
          'อยู่ในกรอบเดียวต่อเนื่อง 2-3 สัปดาห์ก่อนเปลี่ยน',
        ],
      },
    ],
    faqs: [
      {
        q: 'M20 ต่างจาก M15 ตรงไหน',
        a: 'M20 แบ่งหนึ่งชั่วโมงได้ลงตัว 3 แท่ง ส่วน M15 แบ่งได้ 4 แท่ง ความต่างคือจุดเริ่มและจบแท่งไม่ตรงกัน',
        a2: 'ผลในทางปฏิบัติคือแท่ง M20 จะเริ่มที่ต้นชั่วโมงและจบที่ 20 และ 40 นาที ทำให้จุดปิดแท่งตรงกับเวลาทั่วไป ซึ่งช่วยให้เทียบกับข่าวที่ประกาศตอนต้นชั่วโมงได้ง่ายกว่า บางระบบจึงเลือก M20 เพื่อลด noise จากแท่งที่ปิดไม่ตรงรอบเวลา',
      },
      {
        q: 'ใช้กรอบเวลามากเกินไปมีผลเสียไหม',
        a: 'มี เพราะยิ่งดูหลายกรอบ ยิ่งเจอสัญญาณขัดกันเองจนตัดสินใจไม่ได้',
        a2: 'ถ้าใช้ 3 กรอบขึ้นไป คุณจะเจอสัญญาณขัดกันราว 3-4 ใน 10 ครั้ง และมักเลือกตามความอยากมากกว่าข้อมูล วิธีที่ได้ผลคือใช้เพียง 2 กรอบ คือกรอบใหญ่กำหนดทิศและกรอบเล็กระบุจุดเข้า แล้วยอมไม่เทรดเมื่อสองกรอบขัดกัน',
      },
      {
        q: 'เปลี่ยนกรอบแล้วอินดิเคเตอร์ต้องตั้งใหม่ไหม',
        a: 'ค่าที่ตั้งไว้ยังอยู่ แต่ผลลัพธ์เปลี่ยนเพราะคำนวณจากจำนวนแท่งที่ต่างกัน จึงควรทดสอบค่าใหม่',
        a2: 'ตัวอย่างที่เห็นชัดคือ EMA 50 บน H1 ตอบสนองไวกว่า EMA 50 บน H4 ราว 4 เท่าในแง่เวลา เมื่อเปลี่ยนกรอบใหญ่ขึ้น คุณจะรอสัญญาณนานขึ้นมาก ถ้ายังใช้ค่าเดิมควรเข้าใจว่าสัญญาณจะช้าลง ไม่ใช่ระบบเสีย',
      },
    ],
  },
  'mt5-add-trendline': {
    intro: [
      'วาดเส้นแนวโน้มบน MT5 ได้จากแถบเครื่องมือหรือ Insert > Objects เช่นเดียวกับ MT4 แต่ MT5 มีตัวเลือกขยายเส้นต่อเนื่องที่ต้องตั้งให้ถูก',
      'เส้นที่มีคุณภาพมาจากจุดจับที่ตลาดให้ความสำคัญ ไม่ใช่จากความสวยงามของเส้น',
    ],
    sections: [
      {
        heading: 'เลือกจุดจับก่อนวาด',
        paragraphs: [
          'เส้นขาขึ้นลากผ่านจุดต่ำอย่างน้อย 2 จุดที่สูงขึ้น ส่วนขาลงลากผ่านจุดสูงที่ต่ำลง จุดที่ควรใช้คือ swing high หรือ swing low ที่เห็นชัดบนกรอบหลัก',
          'ถ้าจุดนั้นถูกแตะแล้วราคาเด้งกลับอย่างน้อย 30-50 Pip บน H1 ถือว่าเป็นจุดที่ตลาดให้ความสำคัญ',
        ],
        bullets: [
          'ต้องมีอย่างน้อย 2 จุด จุดที่สามเพิ่มความน่าเชื่อถือ',
          'หลีกเลี่ยงจุดที่อยู่ติดกันเกินไป',
          'จุดที่ถูกแตะซ้ำ 3 ครั้งคือแนวที่ตลาดจับตา',
        ],
      },
      {
        heading: 'ขั้นตอนวาดเส้นใน MT5',
        paragraphs: [
          'คลิกไอคอนเส้นทแยงบนแถบเครื่องมือ หรือไปที่ Insert > Objects > Trendline แล้วคลิกจุดเริ่มและลากไปจุดสิ้นสุด',
          'ดับเบิลคลิกที่เส้นเพื่อเปิดหน้าต่าง Properties ซึ่งมีแท็บ Parameters ให้เลือกขยายเส้นต่อเนื่อง (Ray) และแท็บ Colors สำหรับสีและความหนา',
        ],
        bullets: [
          'ลากจากซ้ายไปขวาเพื่อให้อ่านทิศทางง่าย',
          'แท็บ Parameters มีตัวเลือกขยายเส้น (Ray)',
          'ตั้งความหนา 1-2 px พอ',
          'กด Ctrl+B ดูรายการวัตถุทั้งหมด',
        ],
      },
      {
        heading: 'เมื่อไรเส้นใช้ไม่ได้แล้ว',
        paragraphs: [
          'ถ้าราคาปิดผ่านเส้นไปเกิน 1 เท่าของ ATR บนกรอบนั้น ให้ถือว่าเส้นนั้นใช้ไม่ได้แล้ว และควรลากใหม่จากจุดต่ำล่าสุด',
          'อย่าลากเส้นเดิมให้ยาวออกไปเพื่อให้ยังดูเหมือนใช้ได้ เพราะจะทำให้ตั้ง Stop Loss ผิดตำแหน่ง',
        ],
        bullets: [
          'ปิดเกินเส้นชัดเจน = ใช้ไม่ได้แล้ว',
          'เส้นที่ถูกแตะ 3 ครั้งมีน้ำหนักมากกว่า',
          'หลังเบรกให้รอ retest ก่อนสรุป',
          'ลากใหม่จากจุดล่าสุดแทนการยืดเส้นเดิม',
        ],
      },
      {
        heading: 'ข้อผิดพลาดที่พบบ่อย',
        paragraphs: [
          'ข้อผิดพลาดอันดับหนึ่งคือลากเส้นให้พอดีตาโดยเลือกจุดที่ไม่ใช่จุดที่ตลาดเคยตอบสนอง ทำให้ Stop Loss แคบเกินจริง',
          'อีกข้อคือวาดบนกรอบเวลาเล็กแล้วใช้ตัดสินใจบนกรอบใหญ่ ให้เลือกกรอบที่ใช้ตัดสินใจจริงเพียงกรอบเดียว',
        ],
        bullets: [
          'อย่าขยับจุดจับเพื่อให้เส้นสวย',
          'วาดบนกรอบที่ใช้ตัดสินใจจริง',
          'บันทึก Template ถ้าใช้ชุดเดิมบ่อย',
          'เส้นเยอะเกิน 5 เส้นบนกราฟเดียวทำให้อ่านยาก',
        ],
      },
    ],
    faqs: [
      {
        q: 'ตัวเลือก Ray ใน MT5 ใช้ทำอะไร',
        a: 'ขยายเส้นต่อเนื่องออกไปทางขวาไม่จำกัด ใช้เมื่อต้องการเส้นเป็นแนวรับแนวต้านระยะยาว',
        a2: 'ถ้าไม่เปิด Ray เส้นจะหยุดที่จุดสิ้นสุดที่คุณลาก ซึ่งเหมาะกับการมองกรอบแนวโน้มช่วงสั้น ๆ ข้อควรระวังคือเส้นแบบ Ray จะยาวออกไปเรื่อย ๆ จนอาจบังกราฟในอนาคต ควรตั้งสีให้จางกว่าเส้นหลักหรือปิดเมื่อไม่ใช้',
      },
      {
        q: 'ต้องมีจุดแตะกี่จุดถึงใช้ได้',
        a: 'อย่างน้อย 2 จุด และถ้ามี 3 จุดที่ราคาเด้งกลับได้จริงจะน่าเชื่อถือกว่ามาก',
        a2: 'ในทางปฏิบัติ เส้นที่ถูกแตะ 3 ครั้งขึ้นไปมีอัตราการเด้งกลับราว 60-70% ในช่วง 20 แท่งถัดมา ส่วนเส้นที่แตะเพียง 2 ครั้งอยู่ราว 50% ซึ่งใกล้เคียงการเดา ถ้าจะใช้เป็นจุดเข้าควรมีอย่างน้อย 3 จุดหรือมีอินดิเคเตอร์ยืนยันเพิ่ม',
      },
      {
        q: 'ลบเส้นไม่ออกต้องทำอย่างไร',
        a: 'เปิดรายการวัตถุด้วย Ctrl+B แล้วเลือกเส้นนั้นกด Delete ซึ่งแน่นอนกว่าการคลิกที่เส้น',
        a2: 'ถ้าในรายการไม่มีเส้นนั้น ให้ตรวจว่ากำลังดูกราฟคู่เงินและกรอบเวลาเดียวกันหรือไม่ เพราะวัตถุผูกกับกราฟที่วาดไว้ ถ้าเปลี่ยนกรอบเวลาไปแล้วเส้นจะไม่แสดงและลบไม่ได้ ให้กลับไปที่กรอบเดิมก่อน',
      },
    ],
  },
  'mt5-add-text': {
    intro: [
      'ข้อความบนกราฟใช้จดเหตุผลการเข้า จุด Stop Loss หรือระดับราคาที่รออยู่ เป็นบันทึกส่วนตัวที่ช่วยได้มากเวลาย้อนดูกราฟ',
      'ข้อความใน MT5 ผูกกับคู่เงินและกรอบเวลา จึงต้องรู้ข้อจำกัดนี้ก่อนใช้งานจริง',
    ],
    sections: [
      {
        heading: 'เพิ่มข้อความลงบนกราฟ',
        paragraphs: [
          'ไปที่ Insert > Text หรือกดปุ่มตัวอักษร A บนแถบเครื่องมือ จากนั้นคลิกตำแหน่งที่ต้องการแล้วพิมพ์ข้อความ กด Enter เพื่อยืนยัน',
          'ข้อความจะแสดงเป็นตัวอักษรสีที่กำหนด ดับเบิลคลิกเพื่อแก้ไข หรือเลือกแล้วกด Delete เพื่อลบ แนะนำให้วางไว้มุมขวาบนเพื่อไม่บังแท่งเทียน',
        ],
        bullets: [
          'Insert > Text หรือปุ่ม A บนแถบเครื่องมือ',
          'วางมุมขวาบนเพื่อไม่บังราคา',
          'ดับเบิลคลิกเพื่อแก้ไขข้อความ',
          'เลือกแล้วกด Delete เพื่อลบ',
        ],
      },
      {
        heading: 'จดอะไรจึงมีประโยชน์',
        paragraphs: [
          'ข้อความที่มีค่าที่สุดคือเหตุผลที่เข้าเทรด 1 บรรทัด และระดับราคาสำคัญที่ต้องจับตา เช่น แนวต้าน 1.0950 ที่รอเบรก',
          'อีกประเภทที่ควรจดคือบันทึกหลังปิดออเดอร์ เช่น เข้าเร็วเกินไปเพราะกลัวตกรถ ซึ่งช่วยให้เห็นรูปแบบพฤติกรรมเมื่อย้อนดูหลายสัปดาห์',
        ],
        bullets: [
          'เหตุผลที่เข้า 1 บรรทัด',
          'ระดับราคาสำคัญที่รออยู่',
          'บันทึกพฤติกรรมหลังปิดออเดอร์',
          'วันที่ ถ้าต้องย้อนดูนานหลายสัปดาห์',
        ],
      },
      {
        heading: 'ปรับรูปแบบให้อ่านง่าย',
        paragraphs: [
          'ดับเบิลคลิกข้อความเพื่อเปิด Properties แล้วปรับสี ขนาด และฟอนต์ แนะนำขนาด 8-10 px เพราะใหญ่กว่านั้นจะบังกราฟ',
          'ถ้าพื้นกราฟเป็นสีดำ ให้ใช้ตัวอักษรสีเหลืองหรือขาวซึ่งตัดกันชัดที่สุด และหลีกเลี่ยงสีแดงเพราะจะสับสนกับแท่งเทียนขาลง',
        ],
        bullets: [
          'ขนาด 8-10 px พอสำหรับบันทึกสั้น ๆ',
          'เลือกสีที่ตัดกับพื้นหลังกราฟ',
          'หลีกเลี่ยงสีเดียวกับแท่งเทียน',
          'ถ้าข้อความทับกัน ให้ย้ายตำแหน่งแทนการย่อ',
        ],
      },
      {
        heading: 'ข้อควรระวัง',
        paragraphs: [
          'ข้อความจะติดกับกรอบเวลาและคู่เงินที่วาดไว้ ถ้าเปิดกราฟคู่อื่นจะไม่เห็น ซึ่งเป็นพฤติกรรมปกติ ไม่ใช่ข้อผิดพลาด',
          'ถ้าต้องการข้อความเดิมในกราฟใหม่ ให้บันทึกเป็น Template แล้วโหลดในกราฟนั้น หรือจดในบันทึกการเทรดแยกแทน',
        ],
        bullets: [
          'ข้อความผูกกับกรอบเวลาและคู่เงิน',
          'ถ้าหายให้กลับไปที่กราฟเดิม',
          'ใช้ Template ถ้าต้องการย้ายทั้งชุด',
          'ข้อความยาวเกิน 60 ตัวอักษรจะบังกราฟ',
        ],
      },
    ],
    faqs: [
      {
        q: 'ข้อความหายหลังเปลี่ยนคู่เงิน',
        a: 'เป็นพฤติกรรมปกติ เพราะวัตถุผูกกับกราฟและกรอบเวลาเดิม กลับไปที่กราฟเดิมข้อความจะกลับมา',
        a2: 'ถ้าต้องการให้ข้อความติดไปกับทุกกราฟ ให้บันทึกเป็น Template ที่ Charts > Template > Save Template แล้วโหลดในกราฟใหม่ ซึ่งจะยกวัตถุทั้งหมดมาด้วย วิธีนี้ใช้เวลา 2 คลิกและได้ผลกับเส้นแนวโน้มและเส้นแนวนอนเช่นกัน',
      },
      {
        q: 'ใส่ข้อความยาว ๆ ได้ไหม',
        a: 'ได้แต่ไม่แนะนำ เพราะจะบังกราฟจนอ่านแท่งเทียนยาก ให้จำกัดไว้ 1-2 บรรทัดสั้น ๆ',
        a2: 'ข้อความที่ยาวเกิน 60-80 ตัวอักษรจะพาดผ่านกราฟครึ่งจอ ถ้าต้องจดละเอียดให้ใช้สมุดบันทึกการเทรดแทน แล้วเขียนบนกราฟแค่รหัสอ้างอิงสั้น ๆ เช่น setup-04 ซึ่งทำให้ย้อนกลับไปหาบันทึกได้ง่าย',
      },
      {
        q: 'ข้อความบนกราฟพิมพ์ภาษาไทยได้ไหม',
        a: 'ได้ แต่บางฟอนต์อาจแสดงสระหรือวรรณยุกต์ไม่ครบ ให้เปลี่ยนฟอนต์ใน Properties เป็นฟอนต์ที่รองรับภาษาไทย',
        a2: 'ถ้าตัวอักษรซ้อนกันหรือสระหาย ให้เปลี่ยนเป็นฟอนต์มาตรฐานอย่าง Tahoma หรือ Arial ซึ่งรองรับภาษาไทยได้ครบ และควรตั้งขนาด 9-10 px เพื่อให้อ่านออกโดยไม่บังกราฟ',
      },
    ],
  },
  'mt5-objects-list': {
    intro: [
      'รายการวัตถุช่วยให้เห็นทุกเส้นและข้อความบนกราฟในที่เดียว ใช้ลบหรือซ่อนของที่ไม่ต้องการได้เร็ว',
      'MT5 เปิดรายการนี้ด้วย Ctrl+B และไม่มีปุ่มย้อนกลับ จึงควรตรวจให้ดีก่อนลบ',
    ],
    sections: [
      {
        heading: 'เปิดรายการวัตถุ',
        paragraphs: [
          'ไปที่ Charts > Objects List หรือกด Ctrl+B จะมีหน้าต่างแสดงทุกวัตถุบนกราฟพร้อมชื่อและประเภท',
          'ในรายการนี้เลือกวัตถุแล้วกด Edit เพื่อแก้ไข หรือ Delete เพื่อลบ และถ้าต้องการซ่อนชั่วคราวให้ยกเลิกเครื่องหมายในคอลัมน์การมองเห็น',
        ],
        bullets: [
          'Ctrl+B เปิด Objects List',
          'ช่องการมองเห็นใช้ซ่อนโดยไม่ลบ',
          'เลือกหลายรายการได้ด้วย Ctrl+คลิก',
          'ดับเบิลคลิกที่วัตถุเพื่อแก้ไขได้เช่นกัน',
        ],
      },
      {
        heading: 'ตั้งชื่อวัตถุให้สื่อความหมาย',
        paragraphs: [
          'วัตถุที่วาดใหม่จะมีชื่ออัตโนมัติ เช่น Trendline 1 ซึ่งอ่านไม่ออกในภายหลัง ให้เปลี่ยนเป็นชื่อที่สื่อ เช่น trend-h4-uptrend หรือ res-10950',
          'การตั้งชื่อที่ดีช่วยให้หาเส้นที่ต้องการเจอใน 5 วินาที และช่วยให้อ่านกราฟของคนอื่นเข้าใจได้ง่าย',
        ],
        bullets: [
          'ตั้งชื่อตามประเภท-กรอบเวลา-ระดับราคา',
          'หลีกเลี่ยงชื่ออัตโนมัติอย่าง Trendline 7',
          'ลบวัตถุที่ไม่ใช้ทุกสัปดาห์',
          'ชื่อที่ดีช่วยเวลากลับมาดูกราฟเก่า',
        ],
      },
      {
        heading: 'ซ่อนกับลบต่างกันอย่างไร',
        paragraphs: [
          'การซ่อนเหมาะเมื่อยังใช้เส้นอยู่แต่ไม่อยากให้บังกราฟ ส่วนการลบเหมาะกับวัตถุที่ใช้ไม่ได้แล้ว เช่น เส้นที่ถูกเบรกไปนานแล้ว',
          'ข้อควรระวังคือการลบไม่มี undo ให้ตรวจในรายการก่อนว่าวัตถุที่จะลบไม่ใช่แนวรับแนวต้านที่ยังใช้อยู่',
        ],
        bullets: [
          'ซ่อนเมื่อยังใช้อยู่',
          'ลบเมื่อใช้ไม่ได้แล้วจริง ๆ',
          'ไม่มี undo ตรวจก่อนกด Delete',
          'บันทึก Template ก่อนล้างกราฟ',
        ],
      },
      {
        heading: 'เก็บและย้ายชุดวัตถุ',
        paragraphs: [
          'ถ้าใช้เส้นชุดเดิมบ่อย ให้บันทึกเป็น Template ผ่าน Charts > Template > Save Template ซึ่งเก็บวัตถุทุกชิ้นไว้ด้วย',
          'ก่อนลบวัตถุทั้งหมด ควรบันทึก Template สำรองไว้ก่อน เพราะถ้าลบแล้วพบว่าต้องใช้ภายหลังจะกู้คืนไม่ได้',
        ],
        bullets: [
          'Template เก็บวัตถุทุกชิ้น',
          'บันทึกสำรองก่อนล้างกราฟ',
          'Template ใช้ข้ามคู่เงินได้',
          'ไฟล์ Template มีขนาดเล็กมาก เก็บหลายเวอร์ชันได้',
        ],
      },
    ],
    faqs: [
      {
        q: 'ลบวัตถุผิด กู้คืนได้ไหม',
        a: 'กู้คืนไม่ได้เพราะไม่มี undo ต้องวาดใหม่หรือโหลดจาก Template ที่เคยบันทึกไว้',
        a2: 'วิธีป้องกันที่ได้ผลคือบันทึก Template ก่อนจัดกราฟทุกครั้ง ใช้เวลาไม่ถึง 10 วินาที และถ้ามีกราฟหลายหน้าต่างให้บันทึกแยกตามคู่เงินเพื่อไม่ให้ปนกัน ไฟล์ Template มีขนาดเพียงไม่กี่ KB จึงเก็บสำรองหลายเวอร์ชันได้',
      },
      {
        q: 'ทำไมบางวัตถุไม่แสดงในรายการ',
        a: 'รายการแสดงเฉพาะวัตถุของกราฟที่กำลังใช้งานอยู่ ถ้าสลับกรอบเวลาหรือคู่เงิน รายการจะเปลี่ยนตาม',
        a2: 'ให้คลิกบนกราฟที่ต้องการก่อนแล้วกด Ctrl+B อีกครั้ง รายการจะอัปเดตตามกราฟนั้น ถ้ายังไม่เห็นวัตถุที่วาดไว้ ให้ตรวจว่าวัตถุนั้นถูกวาดบนกรอบเวลาอื่นหรือไม่ เพราะ MT5 แยกวัตถุตามกรอบเวลาอย่างชัดเจน',
      },
      {
        q: 'ลบวัตถุทั้งหมดในคลิกเดียวได้ไหม',
        a: 'ทำได้โดยเลือกทุกรายการด้วย Ctrl+A แล้วกด Delete แต่ควรบันทึก Template ไว้ก่อน',
        a2: 'อีกวิธีคือเมนู Charts > Objects > Delete All ซึ่งเร็วกว่าแต่ไม่มีคำเตือนยืนยัน ก่อนทำทุกครั้งให้ Save Template เก็บไว้หนึ่งชุด เพราะถ้าลบแล้วอยากรื้อกราฟกลับมาต้องวาดใหม่ทั้งหมดซึ่งใช้เวลาหลายนาที',
      },
    ],
  },
  'mt5-add-indicator': {
    intro: [
      'MT5 มีอินดิเคเตอร์ในตัว 38 ตัว มากกว่า MT4 อยู่ 8 ตัว เพิ่มได้จาก Navigator หรือ Insert > Indicators',
      'จำนวนที่มากไม่ได้แปลว่าวิเคราะห์เก่งขึ้น การเข้าใจ 2-3 ตัวให้ลึกมีค่ากว่า',
    ],
    sections: [
      {
        heading: 'หมวดอินดิเคเตอร์ใน MT5',
        paragraphs: [
          'MT5 แบ่งอินดิเคเตอร์เป็น Trend, Oscillators, Volumes และ Bill Williams โดย Trend จะวาดบนกราฟราคา ส่วน Oscillators แสดงในหน้าต่างย่อย',
          'ตัวอย่างที่ใช้บ่อยคือ Moving Average และ Bollinger Bands ในหมวด Trend กับ RSI และ Stochastic ในหมวด Oscillators',
        ],
        bullets: [
          'Trend — บนกราฟราคา เช่น Moving Average',
          'Oscillators — หน้าต่างย่อย เช่น RSI, Stochastic',
          'Volumes — ดูปริมาณการซื้อขาย',
          'Bill Williams — กลุ่มเฉพาะทาง',
        ],
      },
      {
        heading: 'ขั้นตอนเพิ่มอินดิเคเตอร์',
        paragraphs: [
          'ไปที่ Insert > Indicators เลือกหมวดและชื่อที่ต้องการ หน้าต่างตั้งค่าจะเปิดขึ้นก่อนวางบนกราฟ ให้ตรวจ Period และระดับสำคัญก่อนกด OK',
          'ถ้าเพิ่มผ่าน Navigator ให้ลากชื่อไปวางบนกราฟ วิธีนี้แม่นกว่าเมื่อมีหลายกราฟ เพราะไม่ต้องกังวลว่าจะไปลงผิดกราฟ',
        ],
        bullets: [
          'Insert > Indicators เข้าถึงครบทุกหมวด',
          'ตรวจ Period ก่อนกด OK',
          'ลากจาก Navigator เมื่อมีหลายกราฟ',
          'แก้ไขภายหลังได้ด้วย Ctrl+I',
        ],
      },
      {
        heading: 'เริ่มจากจำนวนเท่าไร',
        paragraphs: [
          'เริ่มจาก 1-2 ตัวที่เข้าใจหลักการจริง เช่น Moving Average 1 ตัวกับ RSI 1 ตัว เพราะตอบคำถามต่างกันคือทิศทางกับความร้อนแรง',
          'ถ้าเพิ่มเกิน 4 ตัวบนกราฟเดียว พื้นที่กราฟจะเหลือน้อยลงราว 40% และอ่านแท่งเทียนได้ยากขึ้นชัดเจน',
        ],
        bullets: [
          'เริ่มจาก 1-2 ตัวที่เข้าใจ',
          'ไม่ควรเกิน 4 ตัวบนกราฟเดียว',
          'อินดิเคเตอร์ประเภทเดียวกันซ้ำให้ผลคล้ายกัน',
          'ตั้งค่าให้ตรงกับกรอบที่ใช้ตัดสินใจ',
        ],
      },
      {
        heading: 'ข้อผิดพลาดที่พบบ่อย',
        paragraphs: [
          'ข้อผิดพลาดที่พบบ่อยคือเพิ่มอินดิเคเตอร์จากกรอบเล็กแต่ใช้ตัดสินใจบนกรอบใหญ่ ค่าที่เห็นจึงไม่สอดคล้องกับกราฟที่ดูอยู่',
          'อีกจุดคือลบอินดิเคเตอร์ออกแต่ยังเหลือ Template เก่า ทำให้เปิดกราฟใหม่แล้วอินดิเคเตอร์กลับมาทุกครั้ง',
        ],
        bullets: [
          'ตรวจ Template ด้วย ไม่ใช่แค่ลบจากกราฟ',
          'ระวังการเพิ่มซ้ำจนเส้นซ้อนกัน',
          'ถ้ากราฟหน่วงให้ลดจำนวนอินดิเคเตอร์',
          'บันทึกค่าที่ใช้ไว้ในบันทึกการเทรด',
        ],
      },
    ],
    faqs: [
      {
        q: 'MT5 มีอินดิเคเตอร์มากกว่า MT4 ไหม',
        a: 'มากกว่าคือ 38 ตัว เทียบกับ 30 ตัวของ MT4 และมีเครื่องมือวิเคราะห์เพิ่ม เช่น ปฏิทินเศรษฐกิจในตัว',
        a2: 'ตัวที่เพิ่มมาไม่ได้เปลี่ยนหลักการวิเคราะห์ แต่ช่วยเรื่องความสะดวก เช่น การดูปฏิทินข่าวโดยไม่ต้องเปิดเว็บ ในทางปฏิบัติ อินดิเคเตอร์ที่ใช้จริงในการเทรดส่วนใหญ่มีเพียง 3-5 ตัว และมีให้ใช้ครบทั้งใน MT4 และ MT5',
      },
      {
        q: 'ควรใช้อินดิเคเตอร์กี่ตัว',
        a: 'แนะนำ 2-3 ตัวที่ทำหน้าที่ต่างกัน เช่น ตัวบอกแนวโน้ม 1 ตัว และตัวบอกจังหวะ 1 ตัว',
        a2: 'เหตุผลเชิงตัวเลขคือถ้าใช้ 5 ตัวที่มีความแม่นยำ 60% แต่มักขัดกันเอง คุณจะเจอสัญญาณที่ตรงกันเพียงราว 1 ใน 5 ครั้ง และพลาดโอกาสไปมาก การใช้ 2 ตัวที่เข้าใจจริงวัดผลได้ง่ายกว่า',
      },
      {
        q: 'เพิ่มอินดิเคเตอร์แล้วกราฟช้า',
        a: 'ลดจำนวนอินดิเคเตอร์และจำนวนกราฟที่เปิดพร้อมกัน เพราะแต่ละตัวต้องคำนวณใหม่ทุกครั้งที่ราคาเปลี่ยน',
        a2: 'ถ้ายังหน่วง ให้ปิดแท็บ Economic Calendar และลดกราฟ M1 ที่กินทรัพยากรหนักที่สุด MT5 ใช้แรมราว 400-700 MB ในสภาวะปกติ แต่ถ้าเปิด 10 กราฟพร้อมอินดิเคเตอร์ครบอาจใช้เกิน 1.5 GB จนกระตุก',
      },
    ],
  },
  'mt5-indicator-settings': {
    intro: [
      'ปรับค่า Period สี และระดับสัญญาณของอินดิเคเตอร์ได้จากหน้าต่าง Properties โดยไม่ต้องลบแล้วเพิ่มใหม่',
      'ค่าเริ่มต้นไม่ใช่ค่าที่เหมาะกับทุกกรอบเวลา การปรับที่ดีคือการปรับที่ทดสอบซ้ำแล้ว',
    ],
    sections: [
      {
        heading: 'เปิดหน้าต่าง Properties',
        paragraphs: [
          'กด Ctrl+I เพื่อเปิดรายการอินดิเคเตอร์บนกราฟ เลือกตัวที่ต้องการแล้วกด Properties หรือดับเบิลคลิกที่เส้นบนกราฟ',
          'หน้าต่างนี้แบ่งเป็นแท็บ Inputs สำหรับค่าคำนวณ และแท็บ Colors สำหรับสีและความหนาของเส้น',
        ],
        bullets: [
          'Ctrl+I เปิดรายการอินดิเคเตอร์',
          'แท็บ Inputs ปรับ Period และระดับ',
          'แท็บ Colors ปรับสีและความหนา',
          'กด Reset กลับค่าเริ่มต้นได้',
        ],
      },
      {
        heading: 'ค่า Period ที่ใช้กันจริง',
        paragraphs: [
          'Moving Average ที่ใช้บ่อยคือ 20 สำหรับระยะสั้น 50 สำหรับระยะกลาง และ 200 สำหรับแนวโน้มหลัก บน H1 ค่า 200 ครอบคลุมราว 8 วันทำการ',
          'RSI ค่าเริ่มต้น 14 ให้สัญญาณค่อนข้างนิ่ง ถ้าลดเหลือ 7 สัญญาณจะถี่ขึ้นราว 2 เท่าแต่มีสัญญาณหลอกเพิ่มขึ้น',
        ],
        bullets: [
          'MA 20 / 50 / 200 คือชุดที่ใช้แพร่หลาย',
          'RSI 14 เหมาะกับ H1 ขึ้นไป',
          'ค่าที่เล็กลง = ไวขึ้นแต่หลอกง่ายขึ้น',
          'ทดสอบค่าใหม่บนกราฟย้อนหลังก่อนใช้',
        ],
      },
      {
        heading: 'ระดับ Overbought และ Oversold',
        paragraphs: [
          'ค่าเริ่มต้นของ RSI คือ 70 และ 30 ซึ่งบอกว่าราคาอาจร้อนแรงเกินไปในแต่ละทิศ แต่ในตลาดมีแนวโน้ม ราคาอยู่ในโซนนี้ได้นานหลายสิบแท่ง',
          'ถ้าเทรดในตลาดมีแนวโน้ม ให้ปรับเป็น 80 และ 20 เพื่อลดสัญญาณออกก่อนเวลา ซึ่งช่วยลดการออกออเดอร์เร็วเกินไปได้ราวครึ่งหนึ่ง',
        ],
        bullets: [
          'ตลาดไซด์เวย์ใช้ 70 / 30',
          'ตลาดมีแนวโน้มใช้ 80 / 20',
          'อย่าใช้ Overbought เป็นสัญญาณขายเดี่ยว ๆ',
          'จดค่าที่ใช้คู่กับผลลัพธ์ทุกไม้',
        ],
      },
      {
        heading: 'ข้อผิดพลาดที่พบบ่อย',
        paragraphs: [
          'ข้อผิดพลาดที่พบบ่อยคือเปลี่ยนค่าไปเรื่อย ๆ จนไม่รู้ว่าอะไรได้ผล เพราะทุกครั้งที่เปลี่ยนคือการเริ่มนับหนึ่งใหม่',
          'อีกจุดคือตั้งค่าให้กราฟดูสวยแต่ไม่เคยทดสอบกับออเดอร์จริง จนสรุปผิดว่าระบบใช้ไม่ได้',
        ],
        bullets: [
          'อย่าเปลี่ยนค่าบ่อยเกินเดือนละครั้ง',
          'บันทึกค่าที่ใช้ไว้ทุกครั้ง',
          'ค่าเริ่มต้นมักปลอดภัยกว่าการปรับตามความรู้สึก',
          'ถ้าปรับแล้วสับสน ให้กด Reset',
        ],
      },
    ],
    faqs: [
      {
        q: 'ค่าเริ่มต้นของอินดิเคเตอร์ใช้ได้เลยไหม',
        a: 'ใช้ได้ในระดับหนึ่ง โดยเฉพาะเมื่อเพิ่งเริ่ม เพราะถูกออกแบบมาให้ไม่ไวเกินไป',
        a2: 'แต่ต้องรู้ว่าค่าเริ่มต้นอย่าง RSI 14 ถูกปรับมาสำหรับกราฟรายวันเป็นหลัก เมื่อใช้บน M5 สัญญาณจะถี่เกินจริงราว 3-5 เท่า ถ้าเทรดกรอบเล็ก ควรเพิ่ม Period ขึ้นหรือยอมรับว่าต้องกรองสัญญาณเพิ่ม',
      },
      {
        q: 'ทำไมค่า RSI บน MT5 ไม่เท่ากับเว็บอื่น',
        a: 'เพราะแต่ละที่ใช้ราคาปิดและจำนวนแท่งต่างกัน รวมถึงเวลาเปิดปิดแท่งที่อ้างอิงคนละเขตเวลา',
        a2: 'ความต่างมักอยู่ที่ 1-3 จุด ซึ่งไม่มีผลต่อการตัดสินใจ แต่ถ้าต่างเกิน 5 จุด ให้ตรวจว่า Period เท่ากันและดูกรอบเวลาเดียวกันหรือไม่ รวมถึงตรวจว่าโบรกเกอร์ใช้เวลาเซิร์ฟเวอร์เขตไหน เพราะแท่งเทียนจะปิดคนละเวลา',
      },
      {
        q: 'ตั้งค่าแล้วอินดิเคเตอร์หายไป',
        a: 'อาจตั้งสีเป็นสีเดียวกับพื้นหลัง หรือตั้งความหนาเป็น 0 จนมองไม่เห็น',
        a2: 'ให้เปิด Properties อีกครั้งแล้วเปลี่ยนสีเป็นสีที่ตัดกับพื้นหลังและตั้งความหนา 1-2 px ถ้ายังไม่เห็นให้ตรวจว่าอินดิเคเตอร์นั้นแสดงในหน้าต่างย่อยที่ถูกซ่อนอยู่หรือไม่ โดยย่อ Toolbox ลงเพื่อให้เห็นพื้นที่ด้านล่างทั้งหมด',
      },
    ],
  },
  'mt5-find-tools': {
    intro: [
      'MT5 มีเครื่องมือเยอะจนหาชื่อไม่เจอ ใช้ช่องค้นหาใน Navigator และหน้าต่าง Symbols จะหาได้เร็วขึ้นมาก',
      'เครื่องมือที่โหลดจากภายนอกจะอยู่ใต้หมวด Custom ซึ่งเป็นจุดที่คนหาไม่เจอบ่อยที่สุด',
    ],
    sections: [
      {
        heading: 'ค้นหาใน Navigator',
        paragraphs: [
          'เปิด Navigator ด้วย Ctrl+N แล้วพิมพ์ชื่ออินดิเคเตอร์บางส่วนในช่องค้นหาด้านบน รายการจะกรองให้เหลือเฉพาะที่ตรงกัน',
          'ถ้าไม่แน่ใจชื่อ ให้พิมพ์คำกว้าง ๆ เช่น moving หรือ rsi แล้วไล่ดูจากรายการที่กรองได้',
        ],
        bullets: [
          'Ctrl+N เปิด Navigator',
          'พิมพ์บางส่วนของชื่อก็พอ',
          'รายการจะกรองแบบทันที',
          'กดล้างช่องค้นหาเพื่อดูทั้งหมดอีกครั้ง',
        ],
      },
      {
        heading: 'หาเครื่องมือวิเคราะห์อื่น',
        paragraphs: [
          'นอกจากอินดิเคเตอร์แล้ว MT5 ยังมีเครื่องมือในแท็บอื่น เช่น ปฏิทินเศรษฐกิจที่อยู่ใน Toolbox และเครื่องมือวิเคราะห์ในเมนู Insert',
          'ถ้าต้องการหาสินทรัพย์ ให้ใช้ช่องค้นหาในหน้าต่าง Symbols ซึ่งกรองได้ทั้ง Forex หุ้น และดัชนี',
        ],
        bullets: [
          'ปฏิทินเศรษฐกิจอยู่ใน Toolbox',
          'Insert > Objects สำหรับเครื่องมือวาด',
          'ช่องค้นหาใน Symbols ใช้หาสินทรัพย์',
          'ใช้คำย่อภาษาอังกฤษจะหาเจอง่ายกว่า',
        ],
      },
      {
        heading: 'ทำไมหาอินดิเคเตอร์ที่โหลดมาไม่เจอ',
        paragraphs: [
          'อินดิเคเตอร์ที่โหลดจากภายนอกจะอยู่ใต้หัวข้อ Custom ไม่ใช่ Indicators ทำให้หลายคนสรุปว่าติดตั้งไม่สำเร็จ',
          'ถ้าไม่มีจริง ให้ตรวจว่าไฟล์ถูกวางในโฟลเดอร์ MQL5 > Indicators ของข้อมูลแพลตฟอร์ม แล้วรีสตาร์ตโปรแกรมหนึ่งครั้ง',
        ],
        bullets: [
          'อินดิเคเตอร์ภายนอกอยู่ใต้ Custom',
          'ไฟล์ต้องอยู่ใน MQL5 > Indicators',
          'ต้องรีสตาร์ตหลังคัดลอกไฟล์',
          'ไฟล์ .ex4 ของ MT4 ใช้กับ MT5 ไม่ได้',
        ],
      },
      {
        heading: 'จัดระเบียบให้หาง่ายในครั้งหน้า',
        paragraphs: [
          'ถ้าใช้เครื่องมือชุดเดิมบ่อย ให้ลากเข้าที่รายการโปรดหรือบันทึกเป็น Template เพื่อให้เปิดกราฟใหม่แล้วพร้อมใช้ทันที',
          'อีกวิธีคือตั้งชื่อไฟล์อินดิเคเตอร์ให้สื่อความหมายตั้งแต่ตอนติดตั้ง เพื่อให้ค้นหาด้วยคำที่จำได้',
        ],
        bullets: [
          'บันทึก Template ที่มีเครื่องมือครบ',
          'ตั้งชื่อไฟล์ให้สื่อความหมาย',
          'ลบเครื่องมือที่ไม่ใช้ออกเพื่อลดรายการ',
          'จดชื่ออินดิเคเตอร์ที่ใช้ประจำไว้',
        ],
      },
    ],
    faqs: [
      {
        q: 'อินดิเคเตอร์ที่โหลดมาอยู่ไหน',
        a: 'อยู่ใต้หัวข้อ Custom ใน Navigator ไม่ได้อยู่ใต้ Indicators ซึ่งเป็นของที่ติดมากับโปรแกรม',
        a2: 'ถ้าเปิด Custom แล้วยังว่าง ให้ตรวจไฟล์ในโฟลเดอร์ MQL5 > Indicators ซึ่งเปิดได้จาก File > Open Data Folder ไฟล์ต้องเป็นนามสกุล .ex5 สำหรับ MT5 ถ้าเป็น .ex4 แสดงว่าเป็นของ MT4 และใช้ด้วยกันไม่ได้',
      },
      {
        q: 'ค้นหาแล้วไม่เจอแต่แน่ใจว่ามี',
        a: 'อาจพิมพ์ชื่อผิดภาษา หรือรายการยังโหลดไม่ครบ ให้ลองพิมพ์คำสั้น ๆ หรือกด Refresh ที่ Navigator',
        a2: 'อีกสาเหตุที่พบบ่อยคือไฟล์ยังไม่ได้ถูกสแกน เพราะยังไม่รีสตาร์ตโปรแกรม ให้ปิด MT5 แล้วเปิดใหม่หนึ่งครั้ง ซึ่งจะทำให้รายการโหลดใหม่ทั้งหมด ใช้เวลาราว 10-20 วินาที',
      },
      {
        q: 'หาเครื่องมือไม่เจอเลยเพราะหน้าจอเล็ก',
        a: 'ซ่อน Navigator ไว้หรือหน้าต่างถูกย่อจนพื้นที่ด้านซ้ายถูกตัดออก',
        a2: 'ให้กด Ctrl+N เพื่อเปิด Navigator ใหม่ และขยายหน้าต่างโปรแกรมให้เต็มจอ ถ้ายังไม่เห็นให้ตรวจว่าได้ลากแถบแบ่งหน้าต่างไปชิดซ้ายจนสุดหรือไม่ ซึ่งทำให้แผงถูกซ่อนโดยไม่ตั้งใจ',
      },
    ],
  },
};